import React from "react";
import Budget from "../Components/Budget/Budget.js";
export default function Budgeting(props){
    return (<><div>
        <Budget/>
        </div></>);
}